<template>
  <div
    class="ws-state-switch"
    :class="{active:value}"
  >
    <div
      class="ws-state-switch__switch"
      @click="$_onClick()"
    >
      <div class="ws-state-switch__switch-button"></div>
    </div>
    <div
      v-if="value&&activeText"
      class="ws-state-switch__text"
    >{{activeText}}</div>
    <div
      v-else-if="!value&&inactiveText"
      class="ws-state-switch__text"
    >{{inactiveText}}</div>
  </div>
</template>

<script>
export default {
  methods: {
    $_onClick() {
      this.$emit("input", !this.value);
    },
    $_getActive(value) {
      if (this.value === value) {
        return true;
      } else {
        return false;
      }
    },
    $_getDefaultValue() {
      if (this.value === null) {
        this.$emit("input", this.defaultValue);
      }
    },
  },
  props: {
    value: {
      type: [Boolean, Number],
      default: null,
    },
    activeText: String,
    inactiveText: String,
    defaultValue: {
      type: [String, Number, Boolean],
      default: null,
    },
  },
  mounted() {
    this.$_getDefaultValue();
  },
};
</script>

<style lang="scss">
@import "../assets/scss/ws-state-switch.scss";
</style>